/*
 * Factory 47: short note under Redo's Checkout+ buttons (cart page + cart drawer)
 * so customers know free returns & package protection is optional.
 * Added 2026-10-14. Only shows where Redo's toggle actually appears.
 */
(function () {
  var LEAD = 'Heads up: Checkout+ is optional.';
  var TEXT = ' It adds free returns and package protection for a small fee. Prefer to skip it? Just use the "Checkout without free returns" button.';
  var queued = false;

  function addNotes() {
    queued = false;
    document.querySelectorAll('.f47-checkout-plus-note').forEach(function (note) {
      var prev = note.previousElementSibling;
      if (!prev || prev.tagName.toLowerCase() !== 'redo-shopify-toggle') note.remove();
    });
    document.querySelectorAll('redo-shopify-toggle').forEach(function (toggle) {
      var next = toggle.nextElementSibling;
      if (next && next.classList.contains('f47-checkout-plus-note')) return;
      var p = document.createElement('p');
      p.className = 'f47-checkout-plus-note';
      var b = document.createElement('strong');
      b.textContent = LEAD;
      p.appendChild(b);
      p.appendChild(document.createTextNode(TEXT));
      toggle.insertAdjacentElement('afterend', p);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(addNotes);
  }

  function start() {
    addNotes();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
